import { render, staticRenderFns } from "./addGatewayRouting.vue?vue&type=template&id=5a8d95f2&scoped=true"
import script from "./addGatewayRouting.vue?vue&type=script&lang=js"
export * from "./addGatewayRouting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a8d95f2",
  null
  
)

export default component.exports